import React from 'react';
import PropTypes from 'prop-types';

import GeneralAttributes from './GeneralAttributes';
import LocationAttributes from './LocationAttributes';

export default class Geofence extends React.Component {

    static propTypes = {
        geofenceId: PropTypes.string, /* may be undefined for new geofence */
    }

    render() {

        const { geofenceId, stage, editable } = this.props;

        return (
            <div className="resource-details-panel geofence-details edit-mode">{/* edit-mode here */}

                <GeneralAttributes geofenceId={geofenceId} stage={stage} pokeMap={this.props.pokeMap} editable={editable} />

                <LocationAttributes geofenceId={geofenceId} stage={stage} editable={editable} />

            </div>
        )
    }
}
